import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import "../OfferHistory.css";

// conponents
import {
  errorSwal,
  successDeleteSwal,
  successSwal,
} from "../../../helper/sweetalert";
import AnimationLoading from "../../../components/Animationloading";
import PaginationHelper from "../../../components/PaginationHelper";
import EmptyComponent from "../../../components/EmptyComponent";

// apollo-client
import { DELETE_OFFERPRICE_GROUP } from "../../../apollo/offerpricegroup/mutation";
import { GET_OFFERPRICEGROUPS } from "../../../apollo/offerpricegroup/query";
import { useLazyQuery, useMutation } from "@apollo/client";

// react bootrap
import { Form, Table, InputGroup, Row, Col } from "react-bootstrap";

// icons
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import ComfirmModal from "../../../components/ComfirmModal";
import BreadCrumbComponent from "../../../components/BreadCrumbComponent";
import { LINEAR_GRADIENT_BG } from "../../../const";
import { FaCheck, FaHourglassHalf } from "react-icons/fa";
import CustomButtonApp from "../../../components/custom.buttons/CustomButtonApp";

export default function OfferpriceHistory() {
  const history = useHistory();
  const [offerpricegroup, setOfferPriceGroup] = useState();
  const [currentStartDate, setCurrentStartDate] = useState("");
  const [currentEndDate, setCurrentEndDate] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [offerPriceTotal, setOfferPriceTotal] = useState();
  const [searchText, setSearchText] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [Delete, setDelete] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const { _limit, _skip, Pagination_helper } = PaginationHelper();

  // ============== > UseLazyQuery And UseMutaion <==============

  const [
    getOfferPriceGroupDatas,
    { data: offerPriceGroupDatas, loading: offerpriceloading },
  ] = useLazyQuery(GET_OFFERPRICEGROUPS, { fetchPolicy: "network-only" });


  const [deleteofferpricegroup, { loading: deleteloading }] = useMutation(
    DELETE_OFFERPRICE_GROUP
  );


  // useEffect hooks
  useEffect(() => {
    if (offerPriceGroupDatas?.offerpriceGroups) {
      setOfferPriceGroup(offerPriceGroupDatas?.offerpriceGroups?.data);
      setOfferPriceTotal(offerPriceGroupDatas?.offerpriceGroups?.total);
    }
  }, [JSON.stringify(offerPriceGroupDatas?.offerpriceGroups)]);

  useEffect(() => {
    _filter();
  }, []);

  useEffect(() => {
    _filter();
  }, [searchText, currentStartDate, currentEndDate, _skip, pageNumber]);

  // ============== > fuctions <==============

  const _filter = async () => {
    try {
      let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

      let _where = {
        shop: shopId,
        isDeleted: false,
        // isSale: false ,
      };

      // TODO: check if search text is not empty
      if (searchText !== "") {
        _where = {
          ..._where,
          customerName: searchText,
        };
      }

      //check if filter date is set
      if (currentStartDate && currentEndDate) {
        _where = {
          ..._where,
          createdAt_gte: new Date(
            moment(moment(currentStartDate).format("YYYY-MM-DD")).toISOString()
          ),
          createdAt_lt: new Date(
            moment(moment(currentEndDate).add(1, "days")).format("YYYY-MM-DD")
          ).toISOString(),
        };
      }

      // TODO: Get all offer groups
      await getOfferPriceGroupDatas({
        variables: {
          where: _where,
          skip: (_skip - 1) * _limit,
          limit: _limit,
          orderBy: "createdAt_DESC",
        },
      });
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const handleChangeStartDate = (e) => {
    setCurrentStartDate(e?.target?.value);
  };

  const handleChangeEndDate = (e) => {
    setCurrentEndDate(e?.target?.value);
  };

  const handleCheckboxChange = (event) => {
    const itemId = event.target.value;
    setSelectedItems((prevSelectedItems) => {
      if (prevSelectedItems.includes(itemId)) {
        return prevSelectedItems.filter((id) => id !== itemId);
      } else {
        return [...prevSelectedItems, itemId];
      }
    });
  };

  const handleDeleteSelected = async () => {
    try {
      const remainingItems = offerpricegroup.filter(
        (e) => !selectedItems.includes(e.id)
      );
      setOfferPriceGroup(remainingItems);
      setOfferPriceTotal(offerPriceTotal - selectedItems?.length);
      setSelectedItems([]);
      selectedItems.map(async (item) =>
        deleteofferpricegroup({
          variables: {
            where: {
              id: item,
            },
          },
        })
      );
      successSwal("ລົບທັງໜົດສຳເລັດ");
    } catch (error) {
      console.log(error);
    }
  };

  const _confirmeDelete = async () => {
    try {
      if (deleteloading) return;
      await deleteofferpricegroup({
        variables: {
          where: {
            id: Delete?.id,
          },
        },
      });
      _filter();
      successDeleteSwal("ລົບສຳເລັດ");
      setShowDelete(false);
    } catch (err) {
      errorSwal(err);
    }
  };

  const handleShowDelete = (id, customerName) => {
    setDelete({ id, customerName });
    setShowDelete(true);
  };

  return (
    <React.Fragment>
      <div className="offerprice-history-main">
        <BreadCrumbComponent
          txtSecond={`ໃບສະເໜີລາຄາ`}
        />

        <div style={{ padding: "1em 2em" }}>
          <h4>
            <b>ຂໍ້ມູນ ສະເໜີລາຄາ</b>
          </h4>
          <p>
            ປະຫວັດການສະເໜີລາຄາທັງໝົດຂອງຮ້ານ.
          </p>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "1em 2em",
            width: "100%",
            marginTop: '-3em'
          }}>
          <div style={{ width: "100%" }}>
            <Row>
              <Col xs={6}>
                <InputGroup>
                  <InputGroup.Text
                    style={{
                      backgroundColor: "#FFFFFF",
                      marginTop: "32px",
                    }}>
                    <SearchIcon sx={{ color: "#6B7280" }} />
                  </InputGroup.Text>
                  <Form.Control
                    placeholder="ຊື່,ເບີໂທ,ເລກທີບິນ..."
                    aria-label="Recipient's username"
                    aria-describedby="basic-addon2"
                    onChange={(e) => {
                      setSearchText(e.target.value);
                    }}
                    value={searchText}
                    style={{
                      borderLeft: "none",
                      marginTop: "32px",
                    }}
                  />
                </InputGroup>
              </Col>
              <Col xs={3}>
                <Form.Label>ອໍເດີຕັ້ງເເຕ່</Form.Label>
                <Form.Control
                  type="date"
                  value={currentStartDate}
                  onChange={(e) => handleChangeStartDate(e)}
                />
              </Col>
              <Col xs={3}>
                <Form.Label>ຫາວັນທີ</Form.Label>
                <Form.Control
                  type="date"
                  value={currentEndDate}
                  onChange={(e) => handleChangeEndDate(e)}
                />
              </Col>

            </Row>
          </div>
        </div>

        <div style={{ padding: '0 2em' }}>
          {offerpriceloading && !offerPriceGroupDatas?.offerpriceGroups ? (
            <AnimationLoading />
          ) : (
            <>
              {offerpricegroup?.length > 0 ? (
                <Table
                  hover
                  style={{
                    borderCollapse: "collapse",
                    width: "100% ",
                    background: '#fff'
                  }}>
                  <thead
                    style={{
                      background: LINEAR_GRADIENT_BG,
                      borderRadius: " 8px 8px 0px 0px",
                      color: "#FFFFFF",
                    }}>
                    <tr>
                      <th>ລ/ດ</th>
                      <th>ເລກທີບິນ</th>
                      <th>ຊື່ລູກຄ້າ</th>
                      <th>ເບີໂທ</th>
                      <th>ວັນທີ,ເດືອນ,ປີ</th>
                      <th>ສະຖານະ</th>
                      <th style={{ textAlign: 'right' }}>ຈັດການ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {offerpricegroup?.map((e, index) => (
                      <>
                        <tr
                          key={index}
                          onClick={() =>
                            history.push("/offerprice_detail", {
                              state: e,
                            })
                          }
                          style={{ cursor: "pointer" }}>

                          <td>{index + 1 + _limit * (_skip - 1)}</td>
                          <td>{e?.code ?? ""}</td>
                          <td>{e?.customerName ?? "-"} {e?.customerLastName ?? "-"}</td>
                          <td>{e?.phone ?? ""}</td>
                          <td>
                            {" "}
                            {moment(e?.createdAt).format(
                              "DD/MM/YYYY , HH:mm:ss"
                            )}
                          </td>
                          <td style={{ color: e?.isSale ? 'green' : '#FF8A08' }}>
                            {e?.isSale ? (
                              <>
                                <FaCheck style={{ marginRight: '5px' }} />
                                <span>ຂາຍແລ້ວ</span>
                              </>
                            ) : (
                              <>
                                <FaHourglassHalf style={{ marginRight: '5px' }} />
                                <span>ກຳລັງສະເຫນີລາຄາ</span>
                              </>
                            )}
                          </td>



                          <td onClick={(e) => e.stopPropagation()} align="right">
                            <CustomButtonApp
                              startIcon={<DeleteIcon />}
                              variant="outline-danger"
                              onClick={() =>
                                handleShowDelete(e?.id, e?.customerName)
                              }
                            />
                          </td>
                        </tr >
                      </>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <div>
                  {offerpricegroup?.length <= 0 && (
                    <div
                      style={{
                        fontSize: "24px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#6B7280",
                        fontWeight: "400",
                      }}>
                      <EmptyComponent />
                      <p>ຍັງບໍ່ມີປະຫວັດການສະເໜີລາຄາ !!!</p>
                    </div>
                  )}
                </div>
              )}

              {offerPriceTotal > 0 ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}>
                  {offerPriceTotal && (
                    <div className="show">
                      ກຳລັງສະແດງ {50 * _skip - 49}-
                      {50 * _skip > offerPriceTotal
                        ? offerPriceTotal
                        : 50 * _skip}{" "}
                      ຈາກ {offerPriceTotal}
                    </div>
                  )}
                  <div></div>
                  <div>{Pagination_helper(offerPriceTotal, "", ``)}</div>
                  <div />
                </div>
              ) : (
                ""
              )}
            </>
          )}
        </div>
      </div>


      <ComfirmModal
        showConfirmModal={showDelete}
        handleCancel={() => setShowDelete(false)}
        handleConfirm={_confirmeDelete}
        title="ແຈ້ງເຕືອນ"
        text={
          "ທ່ານຕອ້ງການຈະລົບຂໍ້ມູນ" + ` ${Delete?.customerName} ` + `ນີ້ເເທ້ບໍ່`
        }
      />
    </React.Fragment >
  );
}
